'use strict';

var R = require('ramda');

var randInt = function randInt(max) {
  return Math.floor(Math.random() * max);
};

var randElement = function randElement(arr) {
  return arr[randInt(arr.length)];
};

var randElements = function randElements(n, arr) {
  return R.times(randElement.bind(null, arr), n);
};

var optimal = function optimal(optimize, arr) {
  return R.reduce(optimize, R.head(arr), R.tail(arr));
};

var optimizeFromConfig = function optimizeFromConfig(c) {
  return function (a, b) {
    return c.optimize(a.fitness, b.fitness) === a.fitness ? a : b;
  };
};

var bestOf = function bestOf(n) {
  return function (c, pop) {
    return optimal(optimizeFromConfig(c), randElements(n, pop));
  };
};

module.exports = {
  random: function random(c, arr) {
    return randElement(arr);
  },
  bestOf2: bestOf(2),
  bestOf3: bestOf(2),
  bestOfN: bestOf,
  fittest: function fittest(c, arr) {
    return arr[0];
  }
  // tournamen
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/evolutionary/select1.js
 ** module id = 130
 ** module chunks = 0
 **/